import { createContext } from "react";

const HistoryQueueContext = createContext<any>({});

export default HistoryQueueContext;
